module.exports = __webpack_public_path__ + "static/media/modificarMedioPago.2d27ae19.svg";